// extracted by mini-css-extract-plugin
module.exports = {"badges":"Badges_badges__puI62"};